import { FC, PropsWithChildren } from 'react';

import { SidebarMenu } from '@/components/SidebarMenu';
import { IPageWithMenuProps } from '@/types';

export const ContentWithSidebar: FC<PropsWithChildren<IPageWithMenuProps>> = ({ siteMenu, children }) => (
  <div className="container flex w-full flex-col lg:flex-row lg:justify-between lg:space-x-4">
    <SidebarMenu siteMenu={siteMenu} />

    <div className="mb-10 w-full md:mt-16 lg:max-w-full">{children}</div>
  </div>
);
